import {
    call,put,all,race,take
} from "redux-saga/effects";

import {
    loadProjectSuccess,
    loadProjectError,

    loadPhaseSuccess,
    loadPhaseError,

    loadDropdownSuccess,
    loadDropdownError
} from "./action"

import {LOAD_PROJECT_DETAILS, LOAD_PHASE_DETAILS, LOAD_DROPDOWN_PROJECT} from "./constant";

import {loadPhaseDetailsAPI, loadProjectDetailsAPI, loadProjectDropdownAPI} from "./remote";


function* loadProjectDetailsSaga(){
    while(true){
        const load = yield race({
          explicitLoad: take(LOAD_PROJECT_DETAILS),
        });
    
        const { explicitLoad } = load;
        const {projectarg} = explicitLoad;

        if(explicitLoad){
            try{
             const result = yield call(loadProjectDetailsAPI,projectarg);
             
             if(result && result){
                yield put(loadProjectSuccess(result))
             }else{
              yield put(loadProjectSuccess([]))
             }
            }catch(error){
             yield put(loadProjectError(
                    (error&&error.response&&error.response.message) ||
                    "Failed to Fetch"
                ))
            }
        }
    }
};

function* loadPhaseDetailsSaga(){
    while(true){
        const load = yield race({
          explicitLoad: take(LOAD_PHASE_DETAILS),
        });
    
        const { explicitLoad } = load;
        const {projectarg} = explicitLoad;

        if(explicitLoad){
            try{
             const result = yield call(loadPhaseDetailsAPI,projectarg);
             
             if(result && result){
                yield put(loadPhaseSuccess(result))
             }else{
              yield put(loadPhaseSuccess([]))
             }
             console.log(result,"resultno")
             console.log(result.phases,"resultphase")
            }catch(error){
             yield put(loadPhaseError(
                    (error&&error.response&&error.response.message) ||
                    "Failed to Fetch"
                ))
            }
        }
    }
};



function* loadProjectDropdownSaga() {
  while (true) {
    yield race({
      metaData: take(LOAD_DROPDOWN_PROJECT),
    });

    try {
      const projectStatus = yield call(loadProjectDropdownAPI, "projectstatus", "post");

      let dropdownlist = {
        projectStatusOptions:
          (projectStatus &&
            projectStatus.data &&
            projectStatus.data.length > 0 &&
            projectStatus.data
              .filter(c => c.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.projectstatus,
                    value: c._id,
                  }
                )
              )) ||
          [],
            }
            console.log(dropdownlist,"dropdown")
            yield put(loadDropdownSuccess(dropdownlist));
          }catch(error){
            yield put(
            loadDropdownError(
              (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
            )
            );
          }
        }
      };

export default function* recordsSaga() {
  yield all([loadProjectDetailsSaga(),
    loadProjectDropdownSaga(),
   loadPhaseDetailsSaga(),
  ]);
}